/**
 * A global namespace for aria-modal.
 */
const ariaModal = "aria-modal";
export default ariaModal;
